import React, { useState,useEffect } from "react";
import CDialog from "../../../basecomp/components/CDialog";
import CInput from "../../../basecomp/components/CInput2";
import CButton from "../../../basecomp/components/CButton";
import CMainGrid from "../../../basecomp/components/wrapper/CMainGrid";
import CDropDown from "../../../basecomp/components/CDropDown";
import CChooseFile from "../../../basecomp/components/CChooseFile";
import { TextField, Tooltip, Stack } from "@mui/material";
import MatRequestVM from "../viewmodel/MatRequestVM";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import Box from "@mui/material/Box";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Button from "@mui/material/Button";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";


const EmailRequestView = () => {
  const {
    emailFieldsForm,
    handleInputChange,
    handleEmailSubmit,
    handleBulkEmailUpload,
    handleBulkFile,
    isEmailSubmitting,
    isUploading,
    handleEmailBulkFileDownload,
    handleBulkCreationFileDownload,
  } = MatRequestVM();

  const { handleToastOpen } = useToast();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [bulkFileName, setBulkFileName] = useState("");
  const [fileInputKey, setFileInputKey] = useState(0);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const buttonStyle = {
    "& > span > button": {
      background:
        "linear-gradient(135deg, #042560 0%, #042560 100%) !important",
      color: "#ffffff !important",
      borderRadius: "10px !important",
      fontWeight: "700 !important",
      textTransform: "none !important",
      boxShadow: "0 8px 20px rgba(4, 37, 96, 0.25) !important",
      transition: "all 0.2s ease !important",
      "&:hover": {
        transform: "translateY(-2px) !important",
        boxShadow: "0 12px 24px rgba(4, 37, 96, 0.35) !important",
      },
    },
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  // ── Wrap file selection to track locally ─────────────────────────────
  const handleBulkFileWithValidation = (files) => {
    // CInput passes event.target.files (FileList) directly
    const file = files?.[0];

    if (!file) {
      setBulkFileName("");
      handleBulkFile(null);
      return;
    }

    const allowedExtensions = [".xlsx", ".xls", ".csv"];
    const fileExtension = file.name
      .slice(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      handleToastOpen(
        "error",
        "Invalid file type. Please select a .xlsx, .xls or .csv file.",
      );
      setBulkFileName("");
      return;
    }

    setBulkFileName(file.name);
    handleBulkFile(file); // pass plain File to VM
  };
  useEffect(() => {
  const fontId = "lato-font-link";
  if (!document.getElementById(fontId)) {
    const link = document.createElement("link");
    link.id = fontId;
    link.href =
      "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
}, []);

const outerTheme = useTheme();
const localTheme = createTheme(outerTheme, {
  typography: {
    ...outerTheme.typography,
    fontFamily: "Lato, sans-serif",
  },
});

  const handleClearBulkFile = (e) => {
    e.stopPropagation();
    setBulkFileName("");
    handleBulkFile(null);
    setFileInputKey((prev) => prev + 1); // ← forces CChooseFile to remount and clear
  };

  // ── Validate before upload ────────────────────────────────────────────
  const handleBulkUploadWithValidation = () => {
    if (!bulkFileName) {
      handleToastOpen(
        "error",
        "Please select a valid .csv or .xlsx file before clicking Bulk Upload.",
      );
      return;
    }
    handleBulkEmailUpload();
    setBulkFileName("");
  };

  const bulkUploadHeaderContent = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "24px",
        flexWrap: "wrap",
      }}
    >
      {/* ── File chooser with clear button ── */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CChooseFile
          key={fileInputKey} // ← remount to clear input
          cFileType="XCL"
          cTooltipText="Upload excel"
          cHelperText={bulkFileName || "*File Types Excel/CSV"}
          cHandleFileChange={handleBulkFileWithValidation}
        />
        {/* Clear button — only show when file is selected */}
        {bulkFileName && (
          <Box
            onClick={handleClearBulkFile}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 26,
              height: 26,
              borderRadius: "50%",
              backgroundColor: "#fee2e2",
              color: "#ef4444",
              fontSize: 13,
              fontWeight: 800,
              cursor: "pointer",
              flexShrink: 0,
              transition: "all 0.2s ease",
              mb: 2.5, // ← align with input field
              "&:hover": {
                backgroundColor: "#ef4444",
                color: "#ffffff",
              },
            }}
          >
            ✕
          </Box>
        )}
      </Box>
      <Box sx={buttonStyle}>
        <CButton
          cOnClick={handleBulkUploadWithValidation}
          cText="Bulk Upload"
        />
      </Box>
      <Stack direction="row" spacing={5}>
        <Tooltip title="Download email request sample template" arrow>
          <Box sx={buttonStyle}>
            <CButton
              cOnClick={handleEmailBulkFileDownload}
              cText="Email Sample"
              cSize="small"
            />
          </Box>
        </Tooltip>

        <Tooltip title="Download bulk creation sample template" arrow>
          <Box sx={buttonStyle}>
            <CButton
              cOnClick={handleBulkCreationFileDownload}
              cText="Creation Sample"
              cSize="small"
            />
          </Box>
        </Tooltip>
      </Stack>
    </div>
  );

  const dialogContent = (
    
    <CMainGrid container spacing={1} sx={{ marginTop: "1em" }}>
      {Object.keys(emailFieldsForm).map((key) => (
        <CMainGrid item xs={12} sm={6} md={6} lg={4} xl={4} key={key}>
          {key === "date" ? (
            <TextField
              label={emailFieldsForm[key].enter}
              type="date"
              value={emailFieldsForm[key].value || ""}
              onChange={(event) => handleInputChange(key)(event.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: (() => {
                  const d = new Date();
                  d.setFullYear(d.getFullYear() - 1);
                  return d.toISOString().split("T")[0];
                })(),
                max: new Date().toISOString().split("T")[0],
              }}
              fullWidth
              required={emailFieldsForm[key].isRequired}
            />
          ) : emailFieldsForm[key].dropdownValues ? (
            <CDropDown
              cId={`dd_${key}`}
              cHelperText={emailFieldsForm[key].enter}
              cData={emailFieldsForm[key].dropdownValues}
              cOnChange={(selectedValue) =>
                handleInputChange(key)(selectedValue)
              }
              cFullWidth="true"
              cIsRequired={emailFieldsForm[key].isRequired}
              cValue={emailFieldsForm[key].value || ""}
            />
          ) : (
            <CInput
              cOnChange={(value) => handleInputChange(key)(value)}
              cHintText={emailFieldsForm[key].enter}
              cFullWidth="true"
              cIsRequired={emailFieldsForm[key].isRequired}
              cValue={emailFieldsForm[key].value || ""}
              cIsSession={false}
            />
          )}
        </CMainGrid>
      ))}
    </CMainGrid>
  );

  const loading = isEmailSubmitting || isUploading;

  if (loading) return <CBackDrop cOpen={loading} />;

  return (
    <ThemeProvider theme={localTheme}>
    <>
      {/* ── Only style the Email trigger button ── */}
      <Box
        sx={{
          display: "inline-flex",
          "& > span > button": {
            // ← targets only direct CButton, not dialog buttons
            background:
              "linear-gradient(135deg, #042560 0%, #042560 100%) !important",
            color: "#ffffff !important",
            borderRadius: "10px !important",
            fontWeight: "700 !important",
            textTransform: "none !important",
            boxShadow: "0 8px 20px rgba(15, 76, 206, 0.25) !important",
            transition: "all 0.2s ease !important",
            "&:hover": {
              transform: "translateY(-2px) !important",
              boxShadow: "0 12px 24px rgba(37, 99, 235, 0.35) !important",
            },
          },
        }}
      >
        <Tooltip title="Submit the Request" arrow placement="bottom">
          <Button
            id="mct_email_btn"
            variant="contained"
            onClick={handleDialogOpen}
            aria-label="Email"
            sx={{
              minWidth: 0,
              borderRadius: "8px",
              p: 1.2,
              backgroundColor: "#042560",
              boxShadow: "none",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#042560",
                transform: "translateY(-2px)",
                boxShadow: "none",
              },
            }}
          >
            <EmailOutlinedIcon sx={{ fontSize: 20, color: "#ffffff" }} />
          </Button>
        </Tooltip>
      </Box>
      {/* ── Dialog renders outside the Box so its buttons are unaffected ── */}
      <Box
        sx={{
          "& .MuiDialogTitle-root": {
            background:
              "linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important",
          },
          "& .MuiDialogTitle-root *": {
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
        }}
      >
        <CDialog
          cOpen={dialogOpen}
          cHandleClose={handleDialogClose}
          cTitle="Material Email Request"
          cOnSubmitClick={handleEmailSubmit}
          cDialogContent={dialogContent}
          cHeaderContent={bulkUploadHeaderContent}
        />
      </Box>
    </>
    </ThemeProvider>
  );
};

export default EmailRequestView;
